
import { inject, observer } from 'mobx-react'
import _get from 'lodash/get'
import config from '~/config'

import React, { Component } from 'react'
import { withGoogleMap, withScriptjs, GoogleMap } from 'react-google-maps'
import { MAP } from 'react-google-maps/lib/constants'
import { withProps } from 'recompose'

import Station from '~/components/Station'
import SelectedStation from '~/components/SelectedStation'
import SalinityLegend from '~/components/SalinityLegend'

const defaultCenter = _get(config, 'ui.map.defaultCenter')
const defaultZoom = _get(config, 'ui.map.defaultZoom')

@inject('view')
@inject('data')
// @inject('userPoi')

@withProps(({ data }) => ({
  googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&v=3.47&libraries=drawing,places`,
  loadingElement: <div style={{ height: `100%` }} />,
  containerElement: <div style={{ height: `100%` }} />,
  mapElement: <div style={{ height: `100%` }}/>
}))
@withScriptjs
@withGoogleMap
@observer
class DataMap extends Component {
  map = null
  _map = null
  state = {
    bounds: null,
    data: null
  }
  resetZoom = () => {
    this._map.setZoom(defaultZoom)
    this._map.setCenter(defaultCenter)
  }

  onMapMounted = ref => {
    this.map = ref || this.map
    this._map = this.map.context[MAP]
  }

  render () {
    const { view: { stationIds = [] }, data: { mainStationId, stations = [], salinityData } } = this.props
    const MyMapStyle = [
      {
        featureType: 'all',
        elementType: 'all',
        stylers: [
          {
            hue: '#0087ff'
          },
          {
            visibility: 'on'
          }
        ]
      },
      {
        featureType: 'all',
        elementType: 'geometry.fill',
        stylers: [
          {
            visibility: 'on'
          },
          {
            hue: '#0087ff'
          }
        ]
      },
      {
        featureType: 'all',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'on'
          },
          {
            weight: '2.30'
          },
          {
            color: '#ff0000'
          }
        ]
      },
      {
        featureType: 'all',
        elementType: 'labels.text',
        stylers: [
          {
            weight: '5.91'
          },
          {
            visibility: 'on'
          },
          {
            color: '#ff0000'
          }
        ]
      },
      {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#357cbb'
          },
          {
            visibility: 'on'
          },
          {
            weight: '5.79'
          },
          {
            gamma: '1.76'
          },
          {
            lightness: '-47'
          }
        ]
      },
      {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#1e73be'
          },
          {
            weight: '3.15'
          },
          {
            lightness: '100'
          },
          {
            visibility: 'on'
          },
          {
            gamma: '1.64'
          }
        ]
      },
      {
        featureType: 'all',
        elementType: 'labels.icon',
        stylers: [
          {
            color: '#1e73be'
          },
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'geometry.fill',
        stylers: [
          {
            visibility: 'off'
          },
          {
            color: '#ff0000'
          }
        ]
      },
      {
        featureType: 'landscape',
        elementType: 'geometry.fill',
        stylers: [
          {
            visibility: 'on'
          },
          {
            hue: '#0087ff'
          }
        ]
      },
      {
        featureType: 'landscape.man_made',
        elementType: 'all',
        stylers: [
          {
            visibility: 'on'
          },
          {
            hue: '#0087ff'
          }
        ]
      },
      {
        featureType: 'landscape.natural',
        elementType: 'all',
        stylers: [
          {
            visibility: 'on'
          },
          {
            hue: '#00fff6'
          }
        ]
      },
      {
        featureType: 'landscape.natural',
        elementType: 'geometry.fill',
        stylers: [
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'landscape.natural.landcover',
        elementType: 'geometry.fill',
        stylers: [
          {
            visibility: 'on'
          },
          {
            hue: '#ff0000'
          }
        ]
      },
      {
        featureType: 'landscape.natural.landcover',
        elementType: 'geometry.stroke',
        stylers: [
          {
            visibility: 'on'
          },
          {
            hue: '#0087ff'
          }
        ]
      },
      {
        featureType: 'landscape.natural.terrain',
        elementType: 'all',
        stylers: [
          {
            visibility: 'on'
          }
        ]
      },
      {
        featureType: 'landscape.natural.terrain',
        elementType: 'geometry',
        stylers: [
          {
            visibility: 'on'
          },
          {
            hue: '#0087ff'
          }
        ]
      },
      {
        featureType: 'landscape.natural.terrain',
        elementType: 'geometry.fill',
        stylers: [
          {
            visibility: 'on'
          },
          {
            hue: '#0087ff'
          }
        ]
      },
      {
        featureType: 'landscape.natural.terrain',
        elementType: 'labels.icon',
        stylers: [
          {
            hue: '#0087ff'
          },
          {
            visibility: 'on'
          }
        ]
      }
    ]

    // const [stationId] = stationIds || []
    // const sId = Number.parseInt(stationId, 10)
    const stationSalinity = salinityData.get()
    return <div>
      <GoogleMap
        onBoundsChanged={() => this.setState({
          bounds: this.map.getBounds()
        })}
        onZoomChanged={() => ({ onZoomChange }) => {
          onZoomChange(this.map.getZoom())
        }}
        options={{
          mapTypeControl: true,
          zoomControl: true,
          fullscreenControl: false,
          gestureHandling: 'auto',
          styles: MyMapStyle,
          streetViewControl: false
        }}
        ref={this.onMapMounted}
        defaultCenter={defaultCenter}
        defaultZoom={defaultZoom}
      >
        {stations.map(station =>
          stationIds.includes(station.id) ? (
            <SelectedStation
              key={station.id}
              station={station}
              main={station.id === mainStationId}
              salinityRecords={_get(stationSalinity, station.id, [])}
            />
          ) : (
            <Station
              key={station.id}
              station={station}
              main={station.id === mainStationId}
              salinityRecords={_get(stationSalinity, station.id, [])}
            />
          )
        )}
        <SalinityLegend />
      </GoogleMap>
    </div>
  }
}

export default DataMap



// WEBPACK FOOTER //
// ./src/modules/Monitoring/DataMap.js